import useSWR from 'swr';
import { fetchData } from '../services/fetch';

/**
 * EG-41 — CA09: o catálogo global para casar Pilar e Tema vindos da planilha.
 *
 * Usa as mesmas chaves de SWR dos seletores (/pillar e /theme), então na tela
 * de template as requisições são deduplicadas — o hook não acrescenta tráfego,
 * só reaproveita o que os dropdowns já carregam.
 *
 * Devolve undefined enquanto carrega, de propósito: o parser trata a ausência
 * importando a questão sem classificação, em vez de barrar o arquivo.
 */
export const useCatalogoDeClassificacao = () => {
  const { data: pilares } = useSWR('/pillar', fetchData);
  const { data: temas } = useSWR('/theme', fetchData);
  // GRI-02 — CA05: a planilha traz CÓDIGOS ("GRI 305-1"), e é aqui que eles
  // viram id. Mesma chave de SWR do multiselect, então na tela de template a
  // requisição é a mesma.
  const { data: gri } = useSWR('/gri-indicator', fetchData);

  if (!pilares && !temas && !gri) return undefined;

  return { pilares: pilares || [], temas: temas || [], gri: gri || [] };
};
